import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStep1 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 354 330",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M10.5463 292.985H0.575562V293.181H10.5463V292.985Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M107.802 61.8984H3.62415V231.911H107.802V61.8984Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M110.984 61.8984H5.10913V231.911H110.984V61.8984Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M107.802 231.911H3.62415V236.728H107.802V231.911Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M116.28 231.911H10.4049V236.728H116.28V231.911Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M106.529 227.456L106.529 66.3455H9.55632L9.55632 227.456H106.529Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.4226 227.456L43.8133 66.3455H63.1419L50.7512 227.456H31.4226Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.6227 223.025C11.5808 223.026 11.5391 223.019 11.5 223.003C11.461 222.988 11.4254 222.965 11.3954 222.936C11.3653 222.906 11.3415 222.871 11.3252 222.833C11.3089 222.794 11.3005 222.753 11.3006 222.711V69.2449C11.2933 69.1989 11.2961 69.1519 11.3088 69.1071C11.3214 69.0623 11.3436 69.0208 11.3739 68.9854C11.4041 68.95 11.4417 68.9216 11.484 68.9021C11.5262 68.8826 11.5722 68.8726 11.6188 68.8726C11.6653 68.8726 11.7113 68.8826 11.7536 68.9021C11.7959 68.9216 11.8334 68.95 11.8637 68.9854C11.8939 69.0208 11.9161 69.0623 11.9288 69.1071C11.9414 69.1519 11.9442 69.1989 11.937 69.2449V222.711C11.937 222.752 11.9289 222.793 11.9131 222.831C11.8973 222.869 11.8741 222.904 11.8449 222.933C11.8158 222.962 11.7811 222.985 11.743 223.001C11.7048 223.017 11.664 223.025 11.6227 223.025Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M54.9078 227.456L67.2907 66.3455H74.8257L62.4428 227.456H54.9078Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M106.529 227.456L106.529 66.3455H105.963L105.963 227.456H106.529Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M112.037 73.0556H7.85918L7.44275 68.0742H111.628L112.037 73.0556Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M112.037 81.227H7.85918L7.44275 76.2456H111.628L112.037 81.227Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M112.037 89.3906H7.85918L7.44275 84.4092H111.628L112.037 89.3906Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M112.037 97.562H7.85918L7.44275 92.5806H111.628L112.037 97.562Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M112.037 105.726H7.85918L7.44275 100.744H111.628L112.037 105.726Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M112.037 113.897H7.85918L7.44275 108.916H111.628L112.037 113.897Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M353.173 165.078H317.619L320.77 123.475H350.022L353.173 165.078Z",
					fill: "#FDD400"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M345.371 165.078H339.258L337.961 123.475H343.603L345.371 165.078Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M337.176 165.078H333.616V280.814H337.176V165.078Z",
					fill: "#FDD400"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M337.144 216.904H333.648C332.78 216.904 332.076 217.608 332.076 218.476V221.972C332.076 222.84 332.78 223.544 333.648 223.544H337.144C338.012 223.544 338.716 222.84 338.716 221.972V218.476C338.716 217.608 338.012 216.904 337.144 216.904Z",
					fill: "#FFE511"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M337.144 227.542H333.648C332.78 227.542 332.076 228.246 332.076 229.114V232.61C332.076 233.478 332.78 234.182 333.648 234.182H337.144C338.012 234.182 338.716 233.478 338.716 232.61V229.114C338.716 228.246 338.012 227.542 337.144 227.542Z",
					fill: "#FFE511"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M341.026 280.814H329.766C329.766 280.184 330.013 279.58 330.454 279.13C330.895 278.681 331.494 278.422 332.124 278.41H338.59C339.219 278.422 339.819 278.681 340.26 279.13C340.7 279.58 340.947 280.184 340.947 280.814H341.026Z",
					fill: "#FFBF1A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M337.176 165.078H333.616V167.255H337.176V165.078Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M187.214 321.797C271.35 321.797 339.556 317.815 339.556 312.903C339.556 307.991 271.35 304.009 187.214 304.009C103.078 304.009 34.8719 307.991 34.8719 312.903C34.8719 317.815 103.078 321.797 187.214 321.797Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M266.482 278.465H292.458V201.937H266.482V278.465Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M121.903 280.814H290.706V278.465H121.903V280.814Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M266.483 201.937H120.151V278.466H266.483V201.937Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M256.26 232.1H130.357V248.302H256.26V232.1Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M256.26 252.961H130.357V269.162H256.26V252.961Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M165.117 234.929H221.508C221.971 234.927 222.415 234.741 222.742 234.413C223.069 234.085 223.252 233.64 223.252 233.177C223.25 232.715 223.066 232.272 222.739 231.946C222.412 231.619 221.97 231.435 221.508 231.433H165.117C164.655 231.435 164.213 231.619 163.886 231.946C163.559 232.272 163.375 232.715 163.373 233.177C163.373 233.64 163.556 234.085 163.883 234.413C164.21 234.741 164.654 234.927 165.117 234.929Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M256.26 211.248H130.357V227.449H256.26V211.248Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M165.117 214.036H221.508C221.97 214.034 222.412 213.85 222.739 213.523C223.066 213.197 223.25 212.754 223.252 212.292C223.252 211.829 223.069 211.384 222.742 211.056C222.415 210.728 221.971 210.542 221.508 210.54H165.117C164.654 210.542 164.21 210.728 163.883 211.056C163.556 211.384 163.373 211.829 163.373 212.292C163.375 212.754 163.559 213.197 163.886 213.523C164.213 213.85 164.655 214.034 165.117 214.036Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M165.117 255.75H221.508C221.97 255.748 222.412 255.564 222.739 255.237C223.066 254.911 223.25 254.468 223.252 254.006C223.252 253.543 223.069 253.098 222.742 252.77C222.415 252.442 221.971 252.256 221.508 252.254H165.117C164.654 252.256 164.21 252.442 163.883 252.77C163.556 253.098 163.373 253.543 163.373 254.006C163.375 254.468 163.559 254.911 163.886 255.237C164.213 255.564 164.655 255.748 165.117 255.75Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M117.849 201.944L266.482 201.944V199.76L117.849 199.76V201.944Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M294.925 199.752H266.474V201.937H294.925V199.752Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M52.5475 33.6851H186.034V142.529C186.034 143.58 185.322 144.588 184.055 145.331C182.787 146.074 181.068 146.492 179.276 146.492H59.2218C57.4293 146.492 55.7101 146.074 54.4426 145.331C53.1751 144.588 52.463 143.58 52.463 142.529V33.6851H52.5475Z",
					fill: "#EDF3F7"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M61.3162 14.794H177.196C179.527 14.794 181.762 15.7197 183.409 17.3675C185.057 19.0153 185.983 21.2502 185.983 23.5805V33.7187H52.496V23.5805C52.496 22.4238 52.7244 21.2785 53.168 20.2102C53.6117 19.142 54.2619 18.1719 55.0814 17.3555C55.9009 16.5392 56.8735 15.8927 57.9434 15.4531C59.0133 15.0136 60.1595 14.7896 61.3162 14.794Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 123.393,
					y: 56.4678,
					width: 15.1917,
					height: 63.7013,
					fill: "#CCE0F5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 14.7601,
					height: 27.2757,
					transform: "matrix(-1 0 0 1 153.345 64.0635)",
					fill: "#B2D1F0"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 22.501,
					height: 9.6674,
					transform: "matrix(-1 0 0 1 161.085 91.3394)",
					fill: "#90BBE5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 171.644,
					y: 120.169,
					width: 33.059,
					height: 19.1622,
					transform: "rotate(-180 171.644 120.169)",
					fill: "#B2D1F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M175.096 120.169H142.036",
					stroke: "#0066CC",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 34.2675,
					height: 7.16424,
					transform: "matrix(-1 0 0 1 123.393 64.0635)",
					fill: "#B2D1F0"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 6.64633,
					height: 5.2653,
					transform: "matrix(-1 0 0 1 149.287 67.8613)",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 123.393,
					y: 86.0737,
					width: 29.3475,
					height: 14.8464,
					transform: "rotate(-180 123.393 86.0737)",
					fill: "#90BBE6"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 123.393,
					y: 120.169,
					width: 24.6648,
					height: 34.0949,
					transform: "rotate(-180 123.393 120.169)",
					fill: "#90BBE5"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M108.462 101.007H116.662V82.0171H67.375V101.007H67.3751V120.169H108.462V101.007Z",
					fill: "#CCE0F5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 98.7279,
					y: 120.169,
					width: 9.73214,
					height: 19.1622,
					transform: "rotate(-180 98.7279 120.169)",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 109.476,
					y: 120.169,
					width: 9.73215,
					height: 19.1622,
					transform: "rotate(-180 109.476 120.169)",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M174.921 120.169H63.4034",
					stroke: "#0066CC",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 109.064,
					y: 96.0002,
					width: 34.0949,
					height: 6.9916,
					transform: "rotate(-180 109.064 96.0002)",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 117.524,
					y: 78.9966,
					width: 17.6085,
					height: 3.88422,
					transform: "rotate(-180 117.524 78.9966)",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 127.536,
					y: 60.2661,
					width: 6.90532,
					height: 6.90529,
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 127.536,
					y: 70.6235,
					width: 6.90532,
					height: 6.9053,
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 127.536,
					y: 80.9817,
					width: 6.90532,
					height: 6.9053,
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 127.536,
					y: 91.3394,
					width: 6.90532,
					height: 6.90529,
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 127.536,
					y: 101.698,
					width: 6.90532,
					height: 6.90529,
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M171.527 100.138H272.942V182.831C272.942 183.63 272.401 184.396 271.438 184.96C270.475 185.525 269.169 185.842 267.807 185.842H176.598C175.236 185.842 173.93 185.525 172.967 184.96C172.004 184.396 171.463 183.63 171.463 182.831V100.138H171.527Z",
					fill: "#F3F7F9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M178.19 85.7862H266.229C268 85.7862 269.697 86.4895 270.949 87.7414C272.201 88.9932 272.904 90.6912 272.904 92.4616V100.164H171.489V92.4616C171.489 91.5828 171.663 90.7127 172 89.9011C172.337 89.0895 172.831 88.3525 173.454 87.7323C174.076 87.1121 174.815 86.6209 175.628 86.2869C176.441 85.953 177.312 85.7828 178.19 85.7862Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 214.411,
					y: 115.241,
					width: 34.0234,
					height: 50.6029,
					fill: "#90BBE5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 195.092,
					y: 128,
					width: 37.1953,
					height: 37.844,
					fill: "#B2D1F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M253.625 165.844H190.768",
					stroke: "#0066CC",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M214.411 121.873H190.768",
					stroke: "#90BBE5",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 195.092,
					y: 121.873,
					width: 6.5356,
					height: 7.7534,
					stroke: "#90BBE5",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 201.628,
					y: 121.873,
					width: 6.53563,
					height: 7.7534,
					stroke: "#90BBE5",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 208.164,
					y: 121.873,
					width: 6.53564,
					height: 7.7534,
					stroke: "#90BBE5",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.301,
					y: 155.536,
					width: 8.21753,
					height: 10.308,
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M236.757 128H190.768V132.902H224.935V145.877H190.768V150.778H236.757V128Z",
					fill: "#CCE0F5"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 195.092,
					y: 132.902,
					width: 29.8427,
					height: 12.9751,
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M142.086 11.6812H220.608V75.707C220.608 76.3252 220.189 76.9181 219.443 77.3552C218.698 77.7924 217.686 78.0379 216.632 78.0379H146.012C144.958 78.0379 143.946 77.7924 143.201 77.3552C142.455 76.9181 142.036 76.3252 142.036 75.707V11.6812H142.086Z",
					fill: "#F3F7F9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M147.245 0.568886H215.41C216.781 0.568886 218.096 1.11342 219.065 2.08271C220.034 3.05199 220.579 4.36662 220.579 5.7374V11.7011H142.057V5.7374C142.057 5.05699 142.191 4.38327 142.452 3.75489C142.713 3.12652 143.096 2.55587 143.578 2.07567C144.06 1.59547 144.632 1.21517 145.261 0.9566C145.891 0.69803 146.565 0.566269 147.245 0.568886Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M156.967 36.1228L170.057 24.5432L183.147 36.1228V62.5545H156.967V36.1228Z",
					fill: "#CCE0F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M163.386 35.3677L169.931 29.5779L176.476 35.3677V40.0247H163.386V35.3677Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M154.953 38.0998L170.057 24.5432L185.16 38.0998",
					stroke: "#0066CC",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.31,
					y: 47.7024,
					width: 3.14661,
					height: 11.0761,
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 168.483,
					y: 47.7024,
					width: 3.14665,
					height: 11.0761,
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 175.658,
					y: 47.7024,
					width: 3.14662,
					height: 11.0761,
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 183.146,
					y: 47.7024,
					width: 22.5298,
					height: 14.8521,
					fill: "#B2D1F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M208.697 62.5544H153.946",
					stroke: "#0066CC",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 191.14,
					y: 53.2405,
					width: 6.54495,
					height: 9.31403,
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M183.146 47.7024H207.69L204.669 41.7238H183.146V47.7024Z",
					fill: "#90BBE5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M276.094 308.181H270.343L270.351 294.847H276.11L276.094 308.181Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M322.341 297.173L316.833 298.838L310.768 286.746L316.276 285.081L322.341 297.173Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M314.704 299.837C314.34 299.977 313.938 299.991 313.565 299.876C313.444 299.819 313.339 299.732 313.26 299.624C313.182 299.515 313.133 299.388 313.117 299.255C313.098 299.177 313.101 299.094 313.124 299.017C313.148 298.94 313.191 298.87 313.251 298.815C313.769 298.32 315.836 298.886 316.071 298.949C316.096 298.958 316.118 298.974 316.135 298.995C316.151 299.016 316.162 299.04 316.166 299.067C316.167 299.093 316.161 299.119 316.148 299.143C316.136 299.166 316.118 299.186 316.095 299.2C315.657 299.464 315.19 299.678 314.704 299.837ZM313.588 298.933C313.526 298.945 313.469 298.975 313.423 299.019C313.401 299.041 313.386 299.069 313.379 299.1C313.372 299.131 313.374 299.163 313.384 299.192C313.393 299.284 313.424 299.372 313.477 299.448C313.529 299.523 313.6 299.584 313.683 299.624C314.382 299.722 315.092 299.545 315.663 299.129C314.991 298.928 314.286 298.862 313.588 298.933Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M316.071 299.216H316.001C315.356 299.074 313.942 298.187 313.895 297.527C313.89 297.423 313.92 297.32 313.979 297.235C314.039 297.149 314.125 297.086 314.225 297.055C314.318 297.01 314.42 296.987 314.523 296.987C314.627 296.987 314.729 297.01 314.822 297.055C315.608 297.385 316.142 298.957 316.166 299.027C316.177 299.049 316.182 299.073 316.182 299.098C316.182 299.123 316.177 299.147 316.166 299.169L316.071 299.216ZM314.382 297.291C314.361 297.284 314.339 297.284 314.319 297.291C314.162 297.362 314.162 297.44 314.162 297.479C314.162 297.864 315.128 298.579 315.804 298.847C315.623 298.391 315.207 297.503 314.712 297.275C314.601 297.239 314.481 297.245 314.374 297.291H314.382Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M316.276 298.312L322.467 296.442C322.574 296.409 322.689 296.415 322.792 296.458C322.896 296.501 322.981 296.579 323.033 296.678L325.39 301.314C325.445 301.43 325.475 301.557 325.476 301.686C325.478 301.815 325.452 301.943 325.4 302.06C325.347 302.178 325.27 302.284 325.174 302.369C325.077 302.454 324.963 302.518 324.84 302.555C322.671 303.168 321.587 303.341 318.861 304.181C317.187 304.684 311.789 307.403 309.511 308.11C307.232 308.817 306.305 306.586 307.201 306.083C311.2 303.859 314.429 300.583 315.474 298.933C315.659 298.637 315.943 298.417 316.276 298.312Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M267.97 308.519C267.482 308.567 266.992 308.442 266.587 308.165C266.496 308.084 266.427 307.98 266.387 307.865C266.347 307.749 266.338 307.625 266.359 307.505C266.364 307.429 266.389 307.355 266.432 307.292C266.475 307.228 266.534 307.177 266.603 307.144C267.318 306.751 269.581 307.929 269.832 308.063C269.858 308.075 269.879 308.095 269.892 308.121C269.905 308.147 269.909 308.176 269.903 308.204C269.897 308.233 269.882 308.258 269.861 308.278C269.84 308.298 269.813 308.31 269.785 308.314C269.188 308.441 268.58 308.51 267.97 308.519ZM266.98 307.332C266.891 307.328 266.802 307.344 266.721 307.379C266.695 307.396 266.673 307.418 266.656 307.443C266.64 307.469 266.63 307.498 266.626 307.529C266.615 307.609 266.623 307.69 266.649 307.766C266.675 307.843 266.718 307.912 266.776 307.969C267.113 308.283 268.064 308.33 269.337 308.118C268.602 307.722 267.805 307.457 266.98 307.332Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M269.761 308.322H269.706C269.023 308.008 267.703 306.751 267.836 306.114C267.836 305.965 267.986 305.769 268.363 305.737C268.502 305.713 268.646 305.721 268.782 305.761C268.918 305.8 269.043 305.87 269.148 305.965C269.848 306.57 269.934 308.118 269.934 308.189C269.934 308.212 269.928 308.235 269.918 308.255C269.907 308.276 269.891 308.294 269.871 308.307C269.838 308.324 269.799 308.33 269.761 308.322ZM268.457 305.965H268.378C268.127 305.965 268.111 306.091 268.103 306.122C268.025 306.507 268.889 307.489 269.604 307.914C269.57 307.264 269.331 306.642 268.921 306.138C268.79 306.033 268.625 305.98 268.457 305.989V305.965Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M270.406 307.513H276.691C276.804 307.511 276.913 307.55 277 307.622C277.086 307.694 277.144 307.795 277.163 307.906L278.074 313.028C278.096 313.155 278.09 313.285 278.056 313.408C278.022 313.532 277.962 313.647 277.878 313.744C277.795 313.842 277.691 313.92 277.574 313.973C277.457 314.025 277.33 314.052 277.202 314.05C274.939 314.011 271.702 313.877 268.819 313.877C265.487 313.877 262.596 314.058 258.691 314.058C256.334 314.058 255.776 311.701 256.774 311.457C261.323 310.467 265 310.365 268.999 307.961C269.419 307.687 269.905 307.533 270.406 307.513Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M290.881 98.1514C289.868 102.363 289.231 107.58 292.052 110.393C292.052 110.393 290.174 114.667 282.348 114.667C275.198 114.667 278.962 110.393 278.962 110.393C283.676 109.277 283.716 103.463 283.048 100.179L290.881 98.1514Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M270.351 294.855L270.343 301.722H276.102L276.11 294.855H270.351Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M316.276 285.081L310.768 286.754L313.895 292.985L319.411 291.319L316.276 285.081Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M303.563 115.657L296.177 119.9C296.177 119.9 303.924 137.972 303.162 140.894C302.117 144.823 301.591 152.845 299.98 158.054C300.616 158.769 302.769 160.05 303.633 160.019C306.776 153.733 311.899 143.008 311.601 139.37C310.925 131.057 303.563 115.657 303.563 115.657Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M299.98 158.054L294.92 160.144L299.996 164.364C299.996 164.364 304.364 162.392 303.563 158.683L299.98 158.054Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M292.091 164.67L296.876 168.261L299.995 164.364L294.92 160.144L292.091 164.67Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M302.306 111.697C307.664 112.789 312.017 131.929 312.017 131.929L299.948 137.736C299.948 137.736 295.816 128.511 293.993 121.739C292.091 114.636 296.554 110.526 302.306 111.697Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M298 118.282C295.753 115.924 296.774 125.306 297.34 131.544C297.819 132.786 298.283 133.902 298.683 134.852C301.928 130.154 301.143 121.582 298 118.282Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M279.143 112.137C279.143 110.094 278.844 109.128 279.402 108.374C279.96 107.619 291.023 106.724 292.932 107.588C293.584 107.879 293.961 110.817 293.144 112.129C291.95 114.031 279.143 112.137 279.143 112.137Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M279.143 112.137C279.143 110.094 278.844 109.128 279.402 108.374C279.96 107.619 291.023 106.724 292.932 107.588C293.584 107.879 293.961 110.817 293.144 112.129C291.95 114.031 279.143 112.137 279.143 112.137Z",
					fill: "#FDD400"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M270.036 111.996C270.036 111.996 262.478 129.376 267.506 161.747H298.298C298.715 157.033 296.727 133.964 302.306 111.697C298.92 111.039 295.495 110.603 292.052 110.393C287.692 110.141 283.322 110.141 278.962 110.393C275.95 110.697 272.966 111.233 270.036 111.996Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M274.428 120.073L266.799 117.001C266.799 117.001 256.49 134.506 254.338 135.976C249.348 133.241 247.675 134.349 243.793 131.481C242.811 131.584 241.279 132.951 240.76 133.65C243.903 139.7 254.346 147.188 259.508 142.623C265.895 136.974 274.428 120.073 274.428 120.073Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M275.387 117.999C274.24 115.044 271.836 113.811 269.235 114.243C268.088 117.865 266.092 125.824 265.809 137.814L268.795 138.49C268.795 138.49 277.359 123.051 275.387 117.999Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M276.699 115.932C278.412 121.087 267.915 136.251 267.915 136.251L256.679 129.965C258.622 125.235 261.05 120.72 263.923 116.49C268.268 110.448 274.821 110.283 276.699 115.932Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M243.982 131.646L238.851 128.684L235.85 134.656C237.923 135.339 240.094 135.681 242.277 135.669L243.982 131.646Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M236.321 128.684L232.652 132.173L235.85 134.656L238.851 128.684H236.321Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M278.121 92.0936C278.074 92.5572 277.791 92.8793 277.493 92.8793C277.194 92.8793 276.982 92.4707 277.029 92.0072C277.076 91.5436 277.359 91.2214 277.666 91.2214C277.972 91.2214 278.169 91.63 278.121 92.0936Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M278.53 92.1328C277.835 93.5213 276.958 94.8108 275.921 95.9671C276.219 96.2135 276.569 96.3901 276.944 96.4839C277.319 96.5777 277.711 96.5864 278.09 96.5093L278.53 92.1328Z",
					fill: "#ED893E"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M277.571 90.4909L277.453 90.4437C277.424 90.4234 277.399 90.3974 277.38 90.3673C277.361 90.3372 277.348 90.3036 277.342 90.2684C277.337 90.2333 277.338 90.1973 277.346 90.1627C277.354 90.128 277.369 90.0953 277.39 90.0666C277.637 89.696 277.966 89.3875 278.352 89.1653C278.738 88.9431 279.17 88.8132 279.614 88.7859C279.649 88.7869 279.684 88.7948 279.716 88.8092C279.748 88.8236 279.777 88.8441 279.801 88.8697C279.825 88.8952 279.844 88.9252 279.856 88.958C279.868 88.9909 279.874 89.0258 279.873 89.0609C279.869 89.1339 279.838 89.2027 279.786 89.2537C279.733 89.3047 279.664 89.334 279.59 89.3359C279.243 89.3646 278.907 89.4731 278.609 89.653C278.31 89.8329 278.057 90.0793 277.87 90.373C277.837 90.4198 277.791 90.4559 277.738 90.4769C277.685 90.4979 277.627 90.5027 277.571 90.4909Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M293.765 91.6929C292.83 97.3658 292.578 100.721 289.412 103.479C288.407 104.389 287.17 105.004 285.837 105.257C284.505 105.51 283.128 105.391 281.859 104.913C280.59 104.434 279.478 103.616 278.643 102.546C277.809 101.477 277.286 100.198 277.131 98.8508C276.432 93.6651 278.066 85.2658 283.857 83.3172C285.094 82.8634 286.43 82.7454 287.728 82.975C289.026 83.2047 290.239 83.7739 291.246 84.6248C292.252 85.4756 293.016 86.5778 293.458 87.8193C293.901 89.0608 294.006 90.3973 293.765 91.6929Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M281.94 94.1366C280.761 90.4044 279.229 84.6373 283.417 82.5001C287.605 80.363 290.905 83.333 295.47 86.083C300.616 89.1787 297.473 99.0002 291.266 101.31C286.057 103.251 280.973 99.3537 281.94 94.1366Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M282.396 87.2143C278.703 88.2121 276.157 85.8393 277.98 83.105C280.29 79.6243 289.373 80.5357 292.775 84.2993C296.177 88.0628 284.957 89.8621 282.396 87.2143Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M283.802 84.4644C279.292 83.6315 277.446 79.9543 281.225 77.6758C284.792 75.5308 294.818 79.2472 296.491 85.1715C298.165 91.0958 285.169 88.6679 283.802 84.4644Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M295.823 87.2849C296.507 86.7349 299.226 85.9491 299.532 88.9899C298.541 87.995 297.224 87.3898 295.823 87.2849Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M297.772 83.498C298.314 84.1895 299.084 86.908 296.036 87.1987C297.037 86.2119 297.653 84.8993 297.772 83.498Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M285.185 93.8773C284.774 95.103 283.912 96.1259 282.773 96.7373C281.264 97.523 280.219 96.2816 280.416 94.6787C280.581 93.2409 281.563 91.088 283.189 90.9623C284.816 90.8366 285.68 92.3766 285.185 93.8773Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M278.428 161.747C278.428 161.747 283.024 205.747 285.884 222.247C289.027 240.319 311.027 292.49 311.027 292.49L321.123 289.442C321.123 289.442 305.409 241.474 303.924 223.607C302.353 204.207 298.33 161.771 298.33 161.771L278.428 161.747Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M285.507 177.132C285.051 176.44 284.619 176.204 284.203 176.346H284.124C284.028 176.385 283.938 176.438 283.857 176.503C283.773 176.573 283.694 176.649 283.621 176.731C283.574 176.778 283.535 176.833 283.488 176.888C283.441 176.943 283.37 177.053 283.307 177.147C283.164 177.378 283.036 177.616 282.922 177.862C282.859 178.012 282.789 178.169 282.726 178.326C282.663 178.483 282.569 178.727 282.49 178.947C282.411 179.167 282.286 179.544 282.191 179.866C282.191 179.952 282.136 180.031 282.113 180.117C282.089 180.204 282.011 180.479 281.956 180.659L281.838 181.131C281.751 181.445 281.673 181.759 281.594 182.089C281.516 182.419 281.437 182.804 281.359 183.174C281.359 183.299 281.304 183.433 281.272 183.559C281.178 184.03 281.084 184.517 280.989 185.004C282.254 195.957 283.771 208.513 285.091 217.274C285.185 216.991 285.279 216.692 285.374 216.37C285.779 214.911 286.107 213.432 286.356 211.939C288.312 200.648 288.461 181.634 285.507 177.132Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M267.506 161.747C267.506 161.747 264.819 204.789 264.67 222.349C264.513 240.609 268.261 300.394 268.261 300.394H278.011C278.011 300.394 280.958 241.678 282.183 223.74C283.511 204.192 287.746 161.747 287.746 161.747H267.506Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M278.789 297.408C278.828 297.408 278.648 300.591 278.648 300.591H267.404L267.09 297.016L278.789 297.408Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M320.322 285.858C320.573 286.353 321.642 289.457 321.642 289.457L310.571 292.812L308.756 289.826L320.322 285.858Z",
					fill: "#0066CC"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 353.571,
				height: 330,
				fill: "white",
				transform: "translate(0.214111)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgStep1);
export default ForwardRef;
